import { z } from 'zod';

/**
 * Creates a Zod schema for request connection form validation
 * @param t Translation function
 * @returns Zod schema for organization form
 */
export const createConnectionGoogleFormSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    clientId: z.string(),
    oauthScopes: z.string(),
    subjectEmail: z
      .string()
      .trim()
      .min(1, { message: t('validation.email.required') })
      .email({ message: t('validation.email.invalid') }),
  });

export type ConnectionGoogleFormValues = z.infer<
  ReturnType<typeof createConnectionGoogleFormSchema>
>;
